import {atom} from "nanostores";


export const LoadingStore = atom<boolean>(false)